import { Box, Heading } from 'grommet'
import styled, { css } from 'styled-components'

export const Wrapper = styled(Box)`
  &:nth-last-child(n + 2) {
    margin-bottom: ${({ theme }) => theme.newSpaces.xs}px;
  }
`

export const Title = styled(Heading)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title3')}

    color: ${theme.newColors.darkGray};
    margin-bottom: ${theme.newSpaces.xs}px;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title3')}
      
      color: ${theme.newColors.gray};
      text-transform: uppercase;
    `}
  `};
`
